var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49.79,
    height: 50.719,
    viewBox: "0 0 49.79 50.719",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.21)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51,50.613h4.182a1.8,1.8,0,0,0,1.783-2.045L51.855,13Z",
    transform: "translate(-7.403 -2.741)",
    fill: "#f29c1f"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 46,
    rx: 3,
    transform: "translate(-0.21 4.719)",
    fill: "#f0c419"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.613,11.71v5.129H4V11.71A1.715,1.715,0,0,1,5.71,10H39.9A1.715,1.715,0,0,1,41.613,11.71Z",
    transform: "translate(-0.581 -2.305)",
    fill: "#eb710d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.613,18V43.791a1.715,1.715,0,0,1-.5,1.214L36.134,49.98a1.715,1.715,0,0,1-1.214.5H5.71A1.715,1.715,0,0,1,4,48.774V18Z",
    transform: "translate(-0.581 -3.467)",
    fill: "#ecf0f1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.129,42.1a5.134,5.134,0,0,0,5.129-5.129V30.129a5.129,5.129,0,1,0-10.258,0v6.839A5.134,5.134,0,0,0,17.129,42.1ZM13.71,30.129a3.419,3.419,0,1,1,6.839,0v6.839a3.419,3.419,0,1,1-6.839,0Z",
    transform: "translate(-1.742 -4.483)",
    fill: "#547580"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.855,40.387a.855.855,0,1,0,0,1.71h6.839a.855.855,0,1,0,0-1.71H33.129V25.855a.855.855,0,0,0-1.459-.6L28.25,28.67a.855.855,0,0,0,1.209,1.209l1.96-1.96V40.387Z",
    transform: "translate(-4.064 -4.483)",
    fill: "#547580"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.516,48H13.855a.855.855,0,1,0,0,1.71H33.516a.855.855,0,0,0,0-1.71Z",
    transform: "translate(-1.887 -7.821)",
    fill: "#35495e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.83,49a1.724,1.724,0,0,1-.35.5L41.5,54.48a1.724,1.724,0,0,1-.5.35V50.71A1.715,1.715,0,0,1,42.71,49Z",
    transform: "translate(-5.951 -7.966)",
    fill: "#d1d4d1"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.547)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.677,5.274H19.89a4.274,4.274,0,1,0-3.907,5.984.855.855,0,1,1,0,1.71,5.984,5.984,0,1,1,5.642-7.976.786.786,0,0,1,.051.282Z",
    transform: "translate(-9.999 -0.999)",
    fill: "#197989"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.677,5.274H38.89a4.274,4.274,0,1,0-3.907,5.984.855.855,0,1,1,0,1.71,5.984,5.984,0,1,1,5.642-7.976.786.786,0,0,1,.051.282Z",
    transform: "translate(-12.757 -0.999)",
    fill: "#197989"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.f63243a53d0fa97a2ccd33261b7d16aa.svg";
export { ForwardRef as ReactComponent };